import { editStoreBuilder } from '@/main/store/pages/edit/builder';
import { DEFAULT } from '@/main/store/listEditTypes';
import { updateEditActionNoLoading } from '@/main/store/actionsFunctions';

import { NAME as name, CRUMB_LABEL_EDIT } from '../constants';
import { apiProvider } from '../api';
import { editMutations, HromadnaObjednavka } from './types';

export const store = editStoreBuilder({
	name,
	apiProvider,
	crumbLabel: CRUMB_LABEL_EDIT,
	dropdownList: {
		SkladOzn: [],
		VyrobekndOzn: [],
		MioPzn: [],
		PohledavkaPzn: [],
		OdpovedPzn: [],
	},
	edit: {
		SkladOzn: null as number | null,
		VyrazenPrp: null as boolean | null,
		VyrobekndOzn: null as string | null,
		NdNr: null as string | null,
		Text: null as string | null,
		EanCode: null as string | null,
		MioId: null as number | null,
		MioPfx: null as string | null,
		MioNr: null as number | null,
		MioPzn: null as number | null,
		OzakazkaId: null as number | null,
		OzakazkaIdText: null as string | null,
		OzakazkaIdNr: null as number | null,
		ZakazkaId: null as number | null,
		ZakazkaIdText: null as string | null,
		ZakazkaIdNr: null as number | null,
		Poznamka2: null as string | null,
		PohledavkaPzn: null as number | null,
		OdpovedPzn: null as number | null,
		MnozstviObj: null as number | null,
		MnozstviDodano: null as number | null,
		MnozstviObjKor: null as number | null,
		MnozstviVydano: null as number | null,
		SkladmistoId: null as number | null,
		SkladmistoIdSkladmisto: null as string | null,
		SkladmistoIdPopis: null as string | null,
		VstupDat: null as string | null,
		VstupPracId: null as number | null,
		VstupPracIdText: null as string | null,
		EditDat: null as string | null,
		EditPracId: null as number | null,
		EditPracIdText: null as string | null,
	},
	localState: {
		isNdNrChosen: null as boolean | null,
	},
	depTableNames: [],
	depTableSettings: {},
	extraActions: {
		[DEFAULT]: ({ state, commit, dispatch }, filter:{}) => (
			updateEditActionNoLoading(state, commit, dispatch,
				apiProvider.default((state.props.jfnd) ? state.props.jfnd : filter))),
	},
	extraGetters: {},
	extraMutations: {
		[editMutations.CREATE_KONTROLA_ND_MAPPER](state, { data }) {
			state.edit.NdNr = data.NdNr;
			state.edit.Text = data.Text;
			state.localState.isNdNrChosen = data.NdNr !== null;
		},
		[editMutations.ND_OBJEDNAVKA_ND_SKLAD_SELECT_MAPPER](state, { data }) {
			state.edit.NdNr = data.ndnr;
			state.edit.Text = data.text;
			state.localState.isNdNrChosen = data.ndnr !== null;
		},
		[editMutations.ND_OBJEDNAVKA_ZAKAZKA_SELECT_MAPPER](state, { data }) {
			state.edit.ZakazkaId = data.value;
			state.edit.ZakazkaIdText = data.text;
			state.edit.ZakazkaIdNr = data.nr;
		},
		[editMutations.ND_OBJEDNAVKA_OZAKAZKA_SELECT_MAPPER](state, { data }) {
			state.edit.OzakazkaId = data.value;
			state.edit.OzakazkaIdText = data.text;
			state.edit.OzakazkaIdNr = data.nr;
		},
		[editMutations.ND_OBJEDNAVKA_SKLAD_SELECT_MAPPER](state, { data }) {
			state.edit.SkladmistoId = data.id;
			state.edit.SkladmistoIdSkladmisto = data.skladmisto;
			state.edit.SkladmistoIdPopis = data.popis;
		},
	},
	props: {
		filter: {
			MioPzn: null as number | null,
			NdNr: null as string | null,
			Kontrola: null as boolean | null,
		},
		mode: null,
		jfnd: null as HromadnaObjednavka | null,
	},
});
